import React from "react";
import "./footer.css";

function Footer() {
  return (
    <div className="footer">
      <p>
        <span>Timmy &copy; 2022</span>Built With ReactJS and CSS
      </p>
    </div>
  );
}

export default Footer;
